import type { SearchFilters } from '../types/filters'

export const searchFilterKeys = [
  'bodyType',
  'colour',
  'condition',
  'seats',
  'doors',
  'fromEngineSize',
  'toEngineSize',
  'fuelType',
  'make',
  'model',
  'trim',
  'mileage',
  'fromPrice',
  'toPrice',
  'rangeInMiles',
  'gearbox',
  'fromYear',
  'toYear',
  'driveType',
  'store',
  'tags',
  'features',
  'financeType',
  'vehicleYear',
  'monthlyPrice',
  'totalPrice',
] as const

export const validUrlSegmentFilterKeys = [
  'bodyType',
  'colour',
  'condition',
  'seats',
  'doors',
  'fuelType',
  'make',
  'model',
  'trim',
  'gearbox',
  'driveType',
  'vehicleYear', // Only allow vehicleYear (not fromYear/toYear) in URL segments
  'rangeInMiles',
  // Derived from toPrice when no fromPrice is set; monthly vs total follows financeType
  'monthlyPrice',
  'totalPrice',
] as const

export const nonFilterParamKeys = [
  'sortingCriteria',
  'pageSize',
  'pageNumber',
  'useMonthly',
] as const

export const searchParamKeys = [
  ...searchFilterKeys,
  ...nonFilterParamKeys,
] as const

export const defaultFilters: SearchFilters = {
  make: [],
  model: [],
  trim: [],
  bodyType: [],
  colour: [],
  condition: [],
  seats: [],
  doors: [],
  fromEngineSize: [],
  toEngineSize: [],
  fuelType: [],
  mileage: [],
  fromPrice: [],
  toPrice: [],
  rangeInMiles: [],
  gearbox: [],
  fromYear: [],
  toYear: [],
  driveType: [],
  store: [],
  tags: [],
  features: [],
  financeType: [],
  vehicleYear: [],
  monthlyPrice: [],
  totalPrice: [],
}

export const DEFAULT_PAGE_SIZE = 32
const DEFAULT_SORTING_CRITERIA = 3
export const FIRST_PUBLISHED_DATE_DESC_SORT_ORDER = 3
export const DATA_DRIVEN_SORT_ORDER = 14

export const defaultNonFilterParams = {
  sortingCriteria: DEFAULT_SORTING_CRITERIA,
  pageNumber: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  useMonthly: false,
}

export enum SortingCriteria {
  FIRST_PUBLISHED_DATE_ASC = 2,
  FIRST_PUBLISHED_DATE_DESC = 3,
  MILEAGE_ASC = 4,
  MILEAGE_DESC = 5,
  AGE_ASC = 6,
  AGE_DESC = 7,
  MONTHLY_PRICE_ASC = 10,
  MONTHLY_PRICE_DESC = 11,
  FULL_PRICE_ASC = 12,
  FULL_PRICE_DESC = 13,
  DATA_DRIVEN_SORT = 14,
}
